import React from 'react';
import { CountdownParts } from '../hooks/useCountdown';
interface HalloweekCountdownProps {
  countdown: CountdownParts;
}
export function HalloweekCountdown({
  countdown
}: HalloweekCountdownProps) {
  const units = [{
    value: countdown.days,
    label: 'dagar'
  }, {
    value: countdown.hours,
    label: 'timmar'
  }, {
    value: countdown.minutes,
    label: 'minuter'
  }, {
    value: countdown.seconds,
    label: 'sekunder'
  }];
  return <section aria-labelledby="countdown-heading" data-id="element-618" data-mp="25ds1rj80attz">
      <h2 id="countdown-heading" className="text-xl md:text-2xl font-bold text-[#F5EDE3]" data-id="element-619" data-mp="2a5taiv5yu2f9">
        Halloweek lanseras söndag 00:00
      </h2>
      <p className="mt-2 text-[#F5EDE3]/65" data-id="element-620" data-mp="1vf2h5ioq6va1">
        Då släpper vi hela veckans schema och öppnar bokningen.
      </p>

      <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-3" role="timer" aria-live="off" data-id="element-621" data-mp="1mggzrquzpmau">
        {units.map(u => <div key={u.label} className="bg-[#1C1917] rounded-2xl px-5 py-6 md:py-8 flex flex-col items-center" data-id="element-622" data-mp="1qhkh6hsorqe6">
            <span className="text-5xl md:text-7xl font-extrabold text-[#FF7A1A] leading-none tabular-nums tracking-tight" data-id="element-623" data-mp="to72w56zjglz">
              {String(u.value).padStart(2, '0')}
            </span>
            <span className="mt-3 text-sm text-[#F5EDE3]/60" data-id="element-624" data-mp="13m4p6n5ab3by">{u.label}</span>
          </div>)}
      </div>

      <div className="mt-6 rounded-2xl bg-[#FF7A1A] px-6 py-5 md:px-8 md:py-6" data-id="element-625" data-mp="fwacc5kyterp">
        <p className="text-xl md:text-2xl font-extrabold text-[#1A0F08]" data-id="element-626" data-mp="axh0ehlbtvtn">
          Alla aktiviteter behöver förbokas – håll utkik!
        </p>
      </div>
    </section>;
}